import { db } from "../../index";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import {startLoading, stopLoading} from "../loader";

export async function createEvent(userInfos, event) {
  startLoading();

  let snap = await db.ref(`users/${userInfos.uid}/events`).push(event);
  snap = await db
    .ref(`users/${userInfos.uid}/events/${snap.key}`)
    .update({ id: snap.key });

  stopLoading();

  return snap;
}

export async function updateEvent(userInfos, event) {
  startLoading();
  await db.ref(`users/${userInfos.uid}/events/${event.id}`).update(event);
  stopLoading();
}

export async function deleteEvent(userInfos, event_id) {
  if (!Array.isArray(event_id)) {
    event_id = [event_id];
  }

  startLoading();

  let pList = event_id.map(async (id) => {
    if (id) await db.ref(`users/${userInfos.uid}/events/${id}`).remove();
  });

  await Promise.all(pList);

  stopLoading();
}

export function useEvents() {
  const { userInfos } = useContext(UserContext);
  const [events, setEvents] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    db.ref("users/" + userInfos.uid + "/events")
      .once("value")
      .then((snapshot) => {
        let res = [];
        snapshot.forEach(function (childSnapshot) {
          res.push({
            id: childSnapshot.key,
            ...childSnapshot.val(),
          });
        });
        setEvents(res);
        setLoaded(true);
      });
  }, [userInfos.uid]);

  return { events, loaded };
}
